<template>
	<transition 
			appear
			:appear-active-class="$_altLyt_stylePageLayoutAnimation()">
		<v-row	class="customVRow" 
				align="start"
				no-gutters>
			<v-col>
				<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
					<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
						<v-row	:key="contentKey"
								dense>
							<v-col>
								<v-alert
										:border="$_altLyt_styleAlertBorder"
										:color="$_altLyt_styleAlertColor"
										:colored-border="$_altLyt_styleAlertColoredBorder"
										:dark="$_altLyt_styleAlertDark"
										:dense="$_altLyt_styleAlertDense"
										:elevation="$_altLyt_styleAlertElevation"
										:light="$_altLyt_styleAlertLight"
										:outlined="$_altLyt_styleAlertOutlined"
										:prominent="$_altLyt_styleAlertProminent"
										:text="$_altLyt_styleAlertText"
										:tile="$_altLyt_styleAlertTile"
										
										:icon="$_altLyt_styleContentIcon(contentVals)"
										:type="$_altLyt_styleContentType(contentVals)">
									<v-row dense>
										<v-col>
											<template v-if="contentVals.title">
												<v-row dense>
													<v-col>
														<span	class="title"
																v-html="$_altLyt_langContentTitle(contentVals)" />
													</v-col>
												</v-row>
												<v-row dense>
													<v-col>
														<v-divider/>
													</v-col>
												</v-row>
											</template>
											<template v-if="!isFalse($_altLyt_langContentText(contentVals))">
												<v-row dense>
													<v-col>
														<span	class="body-2 markdown"
																v-html="marked($_altLyt_langContentText(contentVals))" />
													</v-col>
												</v-row>
											</template>
										</v-col>
										<v-col class="center" cols="auto">
											<v-row dense>
												<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
													<v-col :key="actionButtonKey" cols="auto">
														<v-btn	class="customVBtn"
																:block="$_altLyt_styleActionButtonBlock"
																:color="$_altLyt_styleActionButtonColor"
																:dark="$_altLyt_styleActionButtonDark"
																:depressed="$_altLyt_styleActionButtonDepressed"
																:elevation="$_altLyt_styleActionButtonElevation"
																:large="$_altLyt_styleActionButtonLarge"
																:light="$_altLyt_styleActionButtonLight"
																:outlined="$_altLyt_styleActionButtonOutlined"
																:rounded="$_altLyt_styleActionButtonRounded"
																:small="$_altLyt_styleActionButtonSmall"
																:text="$_altLyt_styleActionButtonFlat"
																@click="openLink(actionButtonVals.link)"
																v-text="$_altLyt_langActionButtonTitle(actionButtonVals)" />
													</v-col>
												</template>
											</v-row>
										</v-col>
									</v-row>
								</v-alert>
							</v-col>
						</v-row>
					</template>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'AlertLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				colors_: {}
			}
		},
		computed: {
			// state
			$_altLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// lang 
			// (content)
			$_altLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_altLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_altLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_altLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_altLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_altLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_altLyt_styleAlert() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'alert')
			},
			$_altLyt_styleAlertBorder() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.border)
			},
			$_altLyt_styleAlertColor() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.color)
			},
			$_altLyt_styleAlertColoredBorder() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.coloredBorder)
			},
			$_altLyt_styleAlertDark() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.dark)
			},
			$_altLyt_styleAlertDense() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.dense)
			},
			$_altLyt_styleAlertElevation() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.elevation)
			},
			$_altLyt_styleAlertIcon() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.icon)
			},
			$_altLyt_styleAlertLight() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.light)
			},
			$_altLyt_styleAlertOutlined() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.outlined)
			},
			$_altLyt_styleAlertProminent() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.prominent)
			},
			$_altLyt_styleAlertText() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.text)
			},
			$_altLyt_styleAlertTile() {
				const self_ = this;
				const alert_ = self_.$_altLyt_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.tile)
			},
			$_altLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_altLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_altLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_altLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_altLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_altLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_altLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_altLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_altLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_altLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_altLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_altLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_altLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_altLyt_styleContentIcon() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.icon;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getStylesVal(contentVal_)
				}
			},
			$_altLyt_styleContentType() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.type;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getStylesVal(contentVal_)
				}
			}
		},
		methods: {
			$_altLyt_getChanceColor(key) {
				const self_ = this;

				if(self_.colors_[key]) { return self_.colors_[key] }

				self_.colors_[key] = self_.getChanceColor()
				return self_.colors_[key]
			}
		}
	}
</script>

<style scoped>
	.cardActions_ {
		padding-bottom: 16px;
	}
</style>
